module.exports = __webpack_public_path__ + "static/sport/left-bottom.9d1a101.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sparker/left-bottom.png
// module id = cBaQ
// module chunks = 0